import {
  array,
  number,
  minimum,
  maximum,
  nullable,
  literal,
  maxLength,
  minLength,
  optional,
  overwrite,
  strictObject,
  string,
  trim,
  union,
  uuid,
} from 'zod/mini';
import type { infer as Infer } from 'zod/mini';

const text = () => string().check(maxLength(512));
const coordinate = strictObject({
  lat: number().check(minimum(-90), maximum(90)),
  lng: number().check(minimum(-180), maximum(180)),
});
export const feedbackAppStateSchema = strictObject({
  version: literal(1),
  app_version: text(),
  locale: text(),
  viewport: strictObject({ width: number(), height: number() }),
  search: optional(text()),
  measurement: optional(strictObject({
    mode: text(), units: union([literal('km'), literal('mi')]),
    status: text(), failure: nullable(text()),
    selected_route: number(),
    distance_km: nullable(number()), duration_seconds: nullable(number()),
    displayed_result: text(),
    stops: array(strictObject({
      input: text(), query: optional(text()), selected_address: optional(text()),
      point: nullable(coordinate),
    })).check(maxLength(50)),
  })),
});
export type FeedbackAppState = Infer<typeof feedbackAppStateSchema>;

export const feedbackSubmissionSchema = strictObject({
  submission_id: optional(uuid()),
  message: string().check(trim(), minLength(3), maxLength(2000)),
  email: optional(string().check(overwrite((value) => value.trim().slice(0, 320)))),
  page_path: string().check(overwrite((value) => value.trim().slice(0, 512)), minLength(1)),
  app_state: optional(feedbackAppStateSchema),
  context: union([
    literal('map_editor'),
    literal('distance_tool'),
    literal('route_planner'),
    literal('contact_page'),
  ]),
});

export type FeedbackSubmission = Infer<typeof feedbackSubmissionSchema>;
export type FeedbackContext = FeedbackSubmission['context'];
